// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".history-items[data-v-aca5a606]{height:450px;overflow-y:auto}", ""]);
// Exports
module.exports = exports;
